import { useEffect, useRef } from 'react'
import { Stack } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { UserRegSx } from '../../../../components/TextField'
import pxToRem from '../../../../helpers/pxToRem'
import { UserUpdate } from '../../../../redux/userRegistrationSlice'
import styles from '../index.module.scss'
import { RegModalWrapper } from '../ModalContent'
import { setErrorMsg } from '../../../../redux/uiSlice'
import { updateUserInfo } from '../../../../firebase/general-apis'
import z from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import FormInputText from '../../../../components/FormComponents/FormInputText'
import { logger } from '../../../../helpers/logger'
import { selectUserNames, selectUserUid } from '../../../../redux/userSlice'
import { selectTeacherNamesState } from '../../../../redux/teacherSlice'

// const baseSchema = teacherRegSchema.shape.basicDetails.pick({
//     names: true,
// })
const baseSchema = z
    .object({
        firstName: z.string(),
        lastName: z.string(),
        firstNameActual: z.string().optional(),
    })
    .check((ctx) => {
        if (ctx.value.firstNameActual === ctx.value.firstName) {
            ctx.issues.push({
                code: 'custom',
                message: 'Must be different to your first name',
                input: ctx.value.firstNameActual,
                path: ['firstNameActual'],
            })
        }
    })
type FormType = z.infer<typeof baseSchema>

const Names = () => {
    const dispatch = useDispatch()
    const userId = useSelector(selectUserUid)
    const userNames = useSelector(selectUserNames)

    // const reg = useSelector((state: RootState) => state.userReg.fields)

    // const formSchema = useMemo(
    //     () =>
    //         baseSchema.check((ctx) => {
    //             if (
    //                 ctx.value.firstName.value === userNames.firstName &&
    //                 ctx.value.lastName.value === userNames.lastName &&
    //                 ctx.value.firstNameActual === userNames.preferredName
    //             ) {
    //                 ctx.issues.push({
    //                     code: 'custom',
    //                     input: ctx.value,
    //                 })
    //             }
    //         }),
    //     [userNames]
    // )

    const {
        reset,
        handleSubmit,
        control,
        formState: { isValid },
    } = useForm({
        resolver: zodResolver(baseSchema),
        mode: 'onChange',
    })

    const hasAppliedDefault = useRef(false)
    useEffect(() => {
        if (hasAppliedDefault.current || userNames === undefined) return

        hasAppliedDefault.current = true
        reset(userNames)
    }, [reset, userNames])

    const handleUpdate = async (data: FormType) => {
        try {
            logger.debug('handle Submit@!!!')
            if (!userId) throw new Error('User is not authenticated.')

            let updateData: UserUpdate = {}

            // let toUpdate: Record<string, any> = {}

            // toUpdate['firstName'] = {
            //     value: data.firstName,
            //     state: 'submitted',
            // }
            // toUpdate['lastName'] = {
            //     value: data.firstName,
            //     state: 'submitted',
            // }
            // toUpdate['firstNameActual'] = data.firstNameActual
            //     ? {
            //           value: data.firstNameActual,
            //           state: 'submitted',
            //       }
            // : null

            // let newFirstName = !!data.names.preferredName
            //     ? data.names.preferredName
            //     : data.names.firstName
            // let newLastName = data.names.lastName

            const newFirstNameActual =
                !!data.firstNameActual && data.firstNameActual.trim() !== ''
                    ? data.firstNameActual
                    : null

            updateData = {
                user: {
                    path: '/',
                    data: {
                        firstName: data.firstName,
                        firstNameActual: newFirstNameActual,
                        lastName: data.lastName,
                    },
                },
                teacher: {
                    path: '/',
                    data: {
                        firstName: {
                            value: data.firstName,
                            state: 'submitted',
                        },
                        lastName: {
                            value: data.lastName,
                            state: 'submitted',
                        },
                        firstNameActual: newFirstNameActual
                            ? {
                                  value: newFirstNameActual,
                                  state: 'submitted',
                              }
                            : null,
                    },
                },
            }
            await updateUserInfo(userId, updateData)
        } catch (error: any) {
            dispatch(setErrorMsg(error.message))
        }
    }

    const namesState = useSelector(selectTeacherNamesState)

    return (
        <RegModalWrapper
            title="Basic Details"
            handleUpdate={handleSubmit(handleUpdate)}
            state={namesState}
            isAllComplete={isValid}
        >
            <Stack gap={pxToRem(40)} className={styles.modalContainer}>
                <Stack className={styles.titleContainer}>
                    <h5 className={styles.h5}>Names</h5>
                    <p className={styles.p}>
                        Your first and last name must be the names that are
                        displayed on your identity documents and your
                        accreditation.
                    </p>
                </Stack>
                <Stack className={styles.fieldContainer}>
                    <Stack direction={'row'} width="100%" gap={pxToRem(24)}>
                        <FormInputText
                            name="firstName"
                            label={'First Name *'}
                            sx={{ ...UserRegSx, flex: 1 }}
                            control={control}
                        />
                        <FormInputText
                            name="lastName"
                            label={'Last Name *'}
                            sx={{ ...UserRegSx, flex: 1 }}
                            control={control}
                        />
                    </Stack>
                    <FormInputText
                        name="firstNameActual"
                        label="Actual First Name"
                        sx={UserRegSx}
                        control={control}
                    />
                </Stack>
            </Stack>
        </RegModalWrapper>
    )
}

export default Names
